const logger = (...args) => {
  if (process.env.REACT_APP_LOGGER_ENABLED === 'TRUE') {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export default logger;
